/** Full country name for display (never ISO codes or abbreviations). */
export function countryDisplayName(country) {
    return country?.name?.trim() || "";
}
